import React from 'react';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';
import cx from 'classnames';

const InputCard = ({
  onRepeat,
  onBackspace,
  disableRepeat = false,
  disableBackspace = false,
  hidden = false,
  hideRepeat = false,
  showRepeatPointer = false,
  showBackspacePointer = false,
  children,
}) => {
  return (
    <div className={cx('inputCard', { hidden })}>
      {!hideRepeat && (
        <AmiraIconButton
          type={ICON_BUTTON_TYPES.REPEAT_AUDIO}
          secondary
          onClick={onRepeat}
          disabled={disableRepeat}
          pointerPosition="left"
          showPointer={showRepeatPointer}
        />
      )}
      <div className="inputCard__content">
        {children}
      </div>
      <AmiraIconButton
        type={ICON_BUTTON_TYPES.BACKSPACE}
        secondary
        onClick={onBackspace}
        disabled={disableBackspace}
        pointerPosition="left"
        showPointer={showBackspacePointer}
      />
    </div>
  );
};

export default InputCard;
